// --------------------------------------------------------------------------------
// Framework and Libraries
// --------------------------------------------------------------------------------
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns'
import { NgModule } from '@angular/core'
import { HttpModule } from '@angular/http'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { CoreModule } from './@core/core.module'
import { ThemeModule } from './@theme/theme.module'
import { DpDatePickerModule } from 'ng2-date-picker'
import { ChartModule } from 'angular-highcharts'
import { BaseUrlInterceptor } from './base-url.interceptor'

// --------------------------------------------------------------------------------
// Components
// --------------------------------------------------------------------------------
import { AppComponent } from './app.component'
import { AppRoutingModule } from './app-routing.module'
import { ToasterModule } from 'angular2-toaster'

// --------------------------------------------------------------------------------
// Base module
// --------------------------------------------------------------------------------
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    ToasterModule,
    DpDatePickerModule,
    DropDownListModule,
    ChartModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true, useValue: '/' }],
})
export class AppModule {}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/app.module.ts